export default __webpack_public_path__ + "static/media/campton-semibold.4fa4f273.ttf";